// src/components/AvvisoBozza.js
// Avviso «c'è una bozza non salvata» (utils/bozzeLocali.js): dentro il modulo appena aperto
// oppure nell'elenco della scheda (rapportini, sopralluoghi…).
import React from "react";
import { quandoBozza, useBozzeCon, documentoBozza, cancellaBozza } from "../utils/bozzeLocali";
import { confirm } from "../utils/confirm";

const btn = (pieno) => ({
  padding: "6px 12px", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'Inter',sans-serif",
  border: pieno ? "1px solid #7c3aed" : "1px solid #d8b4fe", background: pieno ? "#7c3aed" : "#fff", color: pieno ? "#fff" : "#6d28d9",
});

export default function AvvisoBozza({ testo, salvataIl, onRiprendi, onElimina, style, etichettaRiprendi = "Riprendi" }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", background: "#f5f3ff", border: "1px solid #c4b5fd",
      borderRadius: 10, padding: "10px 12px", margin: "0 0 12px", fontSize: 12.5, color: "#4c1d95", ...style }}>
      <span style={{ fontSize: 18 }}>📝</span>
      <span style={{ flex: 1, minWidth: 180 }}>
        <strong>{testo}</strong>
        {salvataIl ? <span style={{ color: "#6d28d9" }}> · salvata su questo dispositivo il {quandoBozza(salvataIl)}</span> : null}
      </span>
      <button type="button" onClick={onRiprendi} style={btn(true)}>{etichettaRiprendi}</button>
      <button type="button" onClick={onElimina} style={btn(false)}>Elimina bozza</button>
    </div>
  );
}

/**
 * Elenco delle bozze di una scheda (es. tutti i rapportini iniziati e non salvati di questa
 * commessa). documenti: l'elenco dei documenti salvati (con id); una bozza di un documento
 * che non esiste più non si mostra. testoDi(bozza, documento|null) → testo dell'avviso.
 * onRiprendi(documento|null, bozza): apre il modulo con la bozza.
 * idDi(bozza): il documento della bozza, se la chiave lo scrive in un altro modo.
 * tutte: mostra ogni bozza senza cercare il documento (elenco riassuntivo, es. per piano).
 */
export function ElencoBozze({ prefisso, documenti, testoDi, onRiprendi, idDi = (b) => documentoBozza(b.chiave), tutte = false, etichettaRiprendi }) {
  const lista = useBozzeCon(prefisso);
  return lista.map(b => {
    const id = idDi(b);
    const d = tutte || id === "nuovo" ? null : (documenti || []).find(x => x.id === id);
    if (!tutte && id !== "nuovo" && !d) return null;
    return (
      <AvvisoBozza key={b.chiave} testo={testoDi(b, d)} salvataIl={b.salvataIl} etichettaRiprendi={etichettaRiprendi}
        onRiprendi={() => onRiprendi(d, b)}
        onElimina={async () => { if (await confirm("Eliminare la bozza? Quello che avevi scritto e non salvato andrà perso.", { type: "danger", confirmLabel: "Elimina bozza" })) cancellaBozza(b.chiave); }} />
    );
  });
}

/** «del 17/10/2026» dalla data del modulo (AAAA-MM-GG), se c'è. */
export const delGiorno = (data) => (typeof data === "string" && /^\d{4}-\d{2}-\d{2}$/.test(data) ? ` del ${data.split("-").reverse().join("/")}` : "");
